import { render, staticRenderFns } from "./Basic-IT-Module.vue?vue&type=template&id=dc981be4&"
import script from "./Basic-IT-Module.vue?vue&type=script&lang=js&"
export * from "./Basic-IT-Module.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports